// BillingBadge — 메뉴 옆 멤버십 상태 배지 (2026-09-22 대표 결정 「멤버십 메뉴는 권고안대로」)
// 값은 billingState.billingBadge(overview) → { label, tone } (구독 중 · 할 일 · 미납 · 해지 예약 · 중단 · 면제). 시행 전·조회 실패면 null 이라 안 그린다.
// 쓰는 곳: TopNavBar ≡ 메뉴 「멤버십」. (UserSidebar 는 마운트되지 않는 옛 컴포넌트라 쓰지 않는다 — 크리에이터 PC 화면에 왼쪽 사이드바는 없다)
import React from "react";
import { Text } from "@chakra-ui/react";

const TONE = {
  brand: { bg: "brand.50", color: "brand.700" },
  warning: { bg: "statusWash.warning", color: "status.warning" },
  error: { bg: "statusWash.error", color: "status.error" },
  neutral: { bg: "neutral.100", color: "neutral.600" },
};

export default function BillingBadge({ badge, ...rest }) {
  if (!badge) return null;
  const t = TONE[badge.tone] || TONE.neutral;
  return (
    <Text as="span" fontSize="10.5px" fontWeight="700" lineHeight="1" px={1.5} py={1} borderRadius="999px" bg={t.bg} color={t.color} whiteSpace="nowrap" data-billing-badge={badge.tone} {...rest}>
      {badge.label}
    </Text>
  );
}
